import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect, useState } from 'react';
import PageBanner from '../Components/Other/PageBanner'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import { CommonApiFun } from '../Redux/Action/index'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { useNavigate } from 'react-router-dom';
import { routes } from '../MainPage';
function Event(props) {
const navigate=useNavigate()
    const dispatch = useDispatch()
    const [isLoading, setIsloading] = useState(true)
    var eventArr = useSelector((state) => state.eventArr)
    
    useEffect(() => {
        var data = { action: "event" }
        //http://192.169.143.211/~devapp/ansh_clinic/admin/api/Api_controller/post
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
       
            dispatch({ type: 'EVENT_DATA', payload: res.data })
            setIsloading(false)
        }).catch((e) => {
          
        })
    }, [])
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Events of Ansh Homeopathy"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="row news-wrapper article-grid">
                            <div className="news_wrap">
                                <div className="news_box">
                                    {(eventArr.length == 0 && isLoading) ? <div className='loader-box'><div className="loader"></div></div>
                                        : eventArr.length == 0 && 
                                        <div class="not_found">
                                           <span><img src={require('../img/emptyData.png')}/></span><p>No events Found</p>
                                        </div>}
                                    {
                                        eventArr.map((item, index) => {
                                         
                                            var slides = [];
                                            if (item.event_image != "") {
                                                var imagesArr = item.event_image.split(",")
                                                imagesArr.map((eventImg) => {
                                                    slides.push(
                                                        <SwiperSlide className='event__item'>
                                                            <a href="javascript:void(0)" class="event_anchor">

                                                                <img src={eventImg} alt="event list five" />
                                                                </a>
                                                        </SwiperSlide>
                                                    )
                                                })
                                            }
                                          
                                            var next_slider = 'slider-next' + index;
                                            var prev_slider = 'slider-prev' + index;
                                            return (

                                                <>
                                                    {<div class={`event_item`} >

                                                        {item.images != "" ? <><Swiper index={index} spaceBetween={0}
                                                            modules={[Navigation, Pagination]}
                                                            slidesPerView={1}
                                                            effect={"slide"}
                                                            navigation={{
                                                                nextEl: "."+next_slider,
                                                                prevEl: "."+prev_slider,
                                                            }}
                                                            pagination={{
                                                                el: '.slideshow-' + index,
                                                            }}
                                                            breakpoints={{
                                                                320: {
                                                                    slidesPerView: 1,
                                                                },
                                                                768: {
                                                                    slidesPerView: 1,
                                                                },
                                                                992: {
                                                                    slidesPerView: 1,
                                                                }
                                                            }}>
                                                       <SwiperSlide className='event__item'>
                                                            <a href="javascript:void(0)" class="event_anchor">
                                                                
                                                                <img src={item.event_image!=""?item.event_image:require('../img/evnetPlaceHolder.png')} alt="event list five" />
                                                                </a>
                                                        </SwiperSlide>
                                                        </Swiper>
                                                            <div className="swiper-buttons-group">
                                                                <div className={`swiper-button-prev  ${prev_slider}`}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                                                                        <path
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <div className={`swiper-button-next ${next_slider}`}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                                                                        <path
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </> : <a href="javascript:void(0)" class="event_anchor"><img src={require('../img/evnetPlaceHolder.png')} alt="event list five" style={{ border: '1px solid #cbcbcb' }} /></a>}
                                                        {/* {item.images != "" ? <img src={item.images.split(",")[0]} alt="event list five" /> : <img src={require('../img/evnetPlaceHolder.png')} alt="event list five" style={{ border: '1px solid #ccc' }} />} */}

                                                        <div class="event_details" onClick={()=>{navigate(routes.event+"/info",{state:item})}}>
                                                            <h4>{item.title}</h4>
                                                            <span>Date of Event: {item.event_date} {item.start_time}</span>
                                                        </div>
                                                    </div>}
                                                </>
                                            )
                                        }
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </PageWrapper>
    );
}

export default Event;